<template>

  <div class="introduct">
    <Animate ref="animate" />

    <el-row class="title">
      <el-col :offset="3" :span="4" class="title_con">
        <span class="zh">实验室简介</span>
        <span class="xiegang">/ </span>
        <span class="en">Overview</span>
      </el-col>
    </el-row>

    <el-row class="main">
      <el-col :offset="3" :span="18">
        <p class="title"><strong>{{$t('introduct.辽宁省生物大分子计算模拟与信息处理重点实验室')}}</strong></p>
        <p class="content">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{$t('introduct.content3')}}</p>
      </el-col>
    </el-row>

    <el-row class="main">
      <el-col :offset="3" :span="18">
        <p class="title"><strong>{{$t('introduct.辽宁省药物分子模拟与设计工程实验室')}}</strong></p>
        <p class="content">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{$t('introduct.content1')}}</p><!--{{$t('introduct.')}}-->
      </el-col>
    </el-row>

    <el-row class="main">
      <el-col :offset="3" :span="18">
        <p class="title"><strong>{{$t('introduct.沈阳市生物大分子计算模拟与信息处理重点实验室')}}</strong></p>
        <p class="content">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{$t('introduct.content2')}}</p>
      </el-col>
    </el-row>
  </div>

</template>

<script>
  import { ref, reactive, onMounted, getCurrentInstance } from 'vue'
  import Animate from "@/components/common/Animate";


  export default {
    name: "Introduction",
    components:{
      Animate,
    },
    setup(){

      let currentIndex = ref(0);
      let instance = reactive({})
      instance = getCurrentInstance();

      onMounted(() => {
        let timer = setTimeout(function () {
          instance.proxy.$refs.animate.isShow = false
          clearTimeout(timer)
        }, 100)
      })

      return{ currentIndex,

      }
    }

  }
</script>

<style scoped lang="less">

  .introduct{
    padding-bottom: 100px ;
    .title{
      position: relative;
      padding: 30px 0 20px;
      .title_con:after{
        content: '';
        position: absolute;
        width: 40px;
        height: 2px;
        left: 12.5%;
        bottom: 0;
        background: #24a056;
      }
      .zh{
        font-size: 21px;
        color: #333333;
        line-height: 1;
        margin-right: 5px;
      }
      .xiegang{
        font-size: 14px;
        line-height: 1.42857143;
      }
      .en{
        font-size: 16px;
        line-height: 1;
        color: #666;

      }
    }

    .main{
      .title{
        font-size: 18px;
        text-align: center;
      }
      .content{
        color: #888;
        font-size: 14px;
        line-height: 30px;
      }
    }


  }

</style>